module.exports = __webpack_public_path__ + "static/img/rs_js_11.4d3bf35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_11.png
// module id = y2xM
// module chunks = 1